import React from "react";
import { AddPaymentOptions } from "../../utils/payment-controller/types";
import PaymentMethod from "../../../../utilities/data/model/PaymentMethod";

export type OnAddPaymentFn = (
  options: Omit<AddPaymentOptions, "paymentAmount" | "tenderedAmount"> & {
    paymentMethod: PaymentMethod;
    paymentAmount: string;
    tenderedAmount: string;
  }
) => Promise<void>;

// This is a function that is called after a payment is made
// if it returns true, the payment screen will close
export type OnAfterPaymentFn = (canClose: boolean) => Promise<boolean | void>;

export type PaymentRootScreenContextType = {
  // The selected payment method
  paymentMethod: PaymentMethod;
  //optional: the default tendered amount
  tenderedAmount?: number;
  //optional: the minimum amount that can be tendered
  minTenderAmount?: number;
  minRoundedTenderAmount?: number;
};

// Optional context to control the payment process
export type PaymentActionsContextType = {
  // This function provides a way for parent screens to modify the payment process
  onAfterPayment?: OnAfterPaymentFn;
  // This function should not be implemented by any parent screens of the PaymentScreen
  onAddPayment?: OnAddPaymentFn;

  onError?: (error: string) => void;
};

export const PaymentActionsContext = React.createContext<
  PaymentActionsContextType | undefined
>(undefined);

export const PaymentRootScreenContext = React.createContext<
  PaymentRootScreenContextType | undefined
>(undefined);
